<!--工人总结-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      <div class="con-select"
           style="position: absolute; z-index: 9;width: 20%;">
        <el-select v-model="default_con"
                   placeholder="请选择" popper-class="optionsContent"
                   @change="switch_con">
          <el-option
            v-for="item in con_list"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </h1>
    <div v-if="dataNotNull" key="1" class="contraDiv"
         style="width: 100%; height: 100%;top:13%;left: 15%; position: absolute; bottom: 0;font-size: 60px;">
      <dv-scroll-board :config="config" style="margin-top: 30px;margin-left:30px;width:40%;height:80%;"/>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import echarts from 'echarts'

export default {
  props: ['project_id'],
  name: "workers",
  data() {
    return {
      color: this.$store.state.color.chart_color,
      name: "workers",
      dataNotNull: true,
      config: {
        data: [
          ['1)', 'Name1'],
          ['2)', 'Name2'],
          ['3)', 'Name3'],
          ['4)', 'Name4'],
          ['5)', 'Name5'],
          ['6)', 'Name6'],
          ['7)', 'Name7'],
          ['8)', 'Name8'],
          ['9)', 'Name9'],
          ['10)', 'Name10']
        ],
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        align: ['left', 'left']
      },
      default_con: "Contractor A",
      con_list: [
        {label: "Contractor A", value: "1"},
        {label: "Contractor B", value: "2"},
        {label: "Contractor C", value: "3"},
        {label: "Contractor D", value: "4"},
      ],
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    switch_con(label) {
      this.sum = 0
      this.getData(label)
    },
    switch_tag(label) {
      this.sum = 0
      this.getData(label)
    },
  },
  mounted() {
    let that = this


    let postData = {
      project_id: this.project_id,
      type: '0',
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token'),
      bes_project_id: window.localStorage.getItem('bes_project_id')
    }
    // axios.post(this.$store.getters.getCmsServer + "DBProjStaff", postData).then(resp => {
    //     var errNo = resp.data.errno
    //     var errStr = resp.data.errstr_cn
    //     this.myChart.hideLoading()
    //     if (errNo == "0") {
    //         this.dataNotNull = true
    //         var result = resp.data.result;
    //         var data = this.analysisResult(result)
    //         this.myChart.setOption({
    //             legend: {
    //                 data: data.legends,
    //                 itemGap: 24,
    //             },
    //             series: [{
    //                 data: data.workers
    //             }]
    //         })
    //     } else {
    //         this.dataNotNull = false
    //     }
    // }).catch(error => {
    //     alert(error)
    //     this.myChart.hideLoading()
    //     this.dataNotNull = false
    // })
  }
}

</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/HCS/contractor.vue